module.exports="mutation createUser($user: CreateUserInput!) {\n  createUser(user: $user) {\n    id\n  }\n}\n"